import CrudSection from "./CrudSection";

const FIELDS = [
  { name: "title", label: "Title", type: "text", full: true, placeholder: "Offer headline" },
  { name: "description", label: "Description", type: "textarea", full: true },
  { name: "image", label: "Image URL", type: "text", full: true, placeholder: "Banner image" },
  { name: "discount", label: "Discount badge", type: "text", placeholder: "e.g. 20% OFF" },
  { name: "button_text", label: "Button text", type: "text", placeholder: "Know more" },
  { name: "link", label: "CTA link", type: "text", full: true, placeholder: "https://wa.me/…" },
  { name: "expiry", label: "Expiry note", type: "text", placeholder: "e.g. Ends Jan 31" },
  { name: "order", label: "Order", type: "number" },
  { name: "active", label: "Active", type: "checkbox", placeholder: "Show on website" },
];

export default function AdminOffers() {
  return (
    <CrudSection
      title="Offers / Ads"
      endpoint="offers"
      testIdPrefix="offer"
      fields={FIELDS}
      defaultValues={{ active: true, order: 0, button_text: "Know more" }}
      renderRow={(o) => (
        <div className="flex items-center gap-4">
          {o.image ? (
            <img src={o.image} alt="" className="w-14 h-14 rounded-xl object-cover border border-[#1F2547]/10" />
          ) : (
            <div className="w-14 h-14 rounded-xl bg-[#EFE9F7]" />
          )}
          <div className="min-w-0">
            <div className="flex items-center gap-2 mb-1">
              <h3 className="font-display font-bold text-base text-[#1F2547] truncate">{o.title}</h3>
              {o.discount && (
                <span className="text-[10px] font-bold uppercase tracking-[0.15em] px-2 py-0.5 rounded-full bg-[#9F87D8] text-white">
                  {o.discount}
                </span>
              )}
              {!o.active && (
                <span className="text-[10px] font-bold uppercase tracking-[0.15em] px-2 py-0.5 rounded-full bg-red-50 text-red-600">
                  Hidden
                </span>
              )}
            </div>
            <p className="text-sm text-[#5B6079] line-clamp-2">{o.description}</p>
            <div className="text-xs text-[#5B6079] mt-1 font-medium">{o.expiry || "—"}</div>
          </div>
        </div>
      )}
    />
  );
}
